<template>
  <el-dialog
    :title="$t('chainSupplier.addSupplier')"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <el-form :model="addChainSupplierInfo" :rules="rules" ref="form" label-width="150px">
      <el-form-item :label="$t('chainSupplier.supplierName')" prop="name">
        <el-input v-model="addChainSupplierInfo.name" :placeholder="$t('chainSupplier.supplierNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.appId')" prop="appId">
        <el-input v-model="addChainSupplierInfo.appId" :placeholder="$t('chainSupplier.appIdPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.appSecure')" prop="appSecure">
        <el-input v-model="addChainSupplierInfo.appSecure" :placeholder="$t('chainSupplier.appSecurePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.mchId')" prop="mchId">
        <el-input v-model="addChainSupplierInfo.mchId" :placeholder="$t('chainSupplier.mchIdPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.mchKey')" prop="mchKey">
        <el-input v-model="addChainSupplierInfo.mchKey" :placeholder="$t('chainSupplier.mchKeyPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.url')" prop="url">
        <el-input v-model="addChainSupplierInfo.url" :placeholder="$t('chainSupplier.urlPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.beanName')" prop="beanName">
        <el-input v-model="addChainSupplierInfo.beanName" :placeholder="$t('chainSupplier.beanNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.suType')" prop="suType">
        <el-select v-model="addChainSupplierInfo.suType" style="width:100%">
          <el-option :value="1" :label="$t('chainSupplier.suType1')"></el-option>
          <el-option :value="2" :label="$t('chainSupplier.suType2')"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplier.remark')" prop="remark">
        <el-input 
          type="textarea"
          v-model="addChainSupplierInfo.remark"
          :placeholder="$t('chainSupplier.remarkPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="saveChainSupplierInfo">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveChainSupplier } from '@/api/admin/chainSupplier/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddChainSupplier',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      dialogVisible: false,
      addChainSupplierInfo: {
        csId: '',
        name: '',
        appId: '',
        appSecure: '',
        mchId: '',
        mchKey: '',
        url: '',
        remark: '',
        beanName: '',
        statusCd: '0',
        suType: 1,
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('chainSupplier.supplierNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('chainSupplier.supplierNameMaxLength'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('chainSupplier.appIdRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('chainSupplier.appIdMaxLength'), trigger: 'blur' }
        ],
        appSecure: [
          { required: true, message: this.$t('chainSupplier.appSecureRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('chainSupplier.appSecureMaxLength'), trigger: 'blur' }
        ],
        mchId: [
          { required: true, message: this.$t('chainSupplier.mchIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('chainSupplier.mchIdMaxLength'), trigger: 'blur' }
        ],
        mchKey: [
          { required: true, message: this.$t('chainSupplier.mchKeyRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('chainSupplier.mchKeyMaxLength'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('chainSupplier.urlRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('chainSupplier.urlMaxLength'), trigger: 'blur' }
        ],
        beanName: [
          { required: true, message: this.$t('chainSupplier.beanNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('chainSupplier.beanNameMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    resetForm() {
      this.addChainSupplierInfo = {
        csId: '',
        name: '',
        appId: '',
        appSecure: '',
        mchId: '',
        mchKey: '',
        url: '',
        remark: '',
        beanName: '',
        statusCd: '0',
        suType: 1,
        shopId: getShopId()
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    saveChainSupplierInfo() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        
        if (this.callBackListener) {
          this.$emit(this.callBackListener, this.callBackFunction, this.addChainSupplierInfo)
          this.dialogVisible = false
          return
        }

        saveChainSupplier(this.addChainSupplierInfo).then(response => {
          const res = response.data
          if (res.code === 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('listChainSupplier')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.message)
        })
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.el-input, .el-textarea {
  width: 100%;
}
</style>